export default __webpack_public_path__ + "static/media/img3.9333ccf6.jpg";